import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	input,
} from '@angular/core';
import { AnalysisColorCode } from '../box-distribution-card-base.component';

@Component({
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-distribution-box',
	template: `
		<p
			class="font-semibold whitespace-pre-wrap text-xxs line-clamp-1 break-all"
		>
			<ng-content />
		</p>
	`,
	host: {
		class: 'rounded-md h-full flex items-center justify-center w-full border-2 hover:scale-x-[1.03] hover:scale-y-[1.03] duration-300',
	},
})
export class DistributionBoxComponent {
	readonly code = input<AnalysisColorCode>('gray');

	@HostBinding('class')
	get colors(): string {
		return `bg-${this.code()}-100 border-${this.code()}-600`;
	}
}
